import { EnvironmentProviders, inject, makeEnvironmentProviders, provideEnvironmentInitializer } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DraftConversationChangesService } from '@shared/modules/conversations/services/draft-conversation-changes/draft-conversation-changes.service';

export function provideDraftConversationChanges(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideEnvironmentInitializer(() =>
      inject(DraftConversationChangesService).init$().pipe(takeUntilDestroyed()).subscribe()
    )
  ]);
}
